import React, {useState, useEffect} from 'react';
import {TStat} from "../../../../types";
import './StatisticContent.component.scss';

/* ----- Main Component ----- */
const StatisticContent = () => {
  const [statData, setStatData] = useState<TStat>();
  const [maxStatValue, setMaxStatValue] = useState<number>(0);

  useEffect(() => {
    let maxStatValue: number = 0;

    statData?.guesses.forEach(item => {
      if (+item > maxStatValue) maxStatValue = +item
    });

    setMaxStatValue(maxStatValue)
  }, [statData]);

  useEffect(() => {
    const storageData = localStorage.getItem('gamesData');
    setStatData(storageData ? JSON.parse(storageData).stat : undefined);
  }, []);

  const renderStatData = (fieldName: string, val: number) => (
    <div className="statistic-content__stat-data">
      <div className="statistic-content__stat-data_val">{val}</div>
      <div className="statistic-content__stat-data_field">{fieldName}</div>
    </div>
  );

  if (statData) {
    const {guesses, Played, Win, MaxStreak, CurrentStreak} = statData;

    return (
      <div className="statistic-content">
        {
          <div className="statistic-content__common-stat">
            {renderStatData('Played', Played)}
            {renderStatData('Win', Win)}
            {renderStatData('Current Streak', CurrentStreak)}
            {renderStatData('Max Streak', MaxStreak)}
          </div>
        }
        <div className="statistic-content__graph-stat">
          <p>Guess</p>

          <div>
            {guesses.map((item, index) => (
              <div className='statistic-content__attempt' key={String(index)}>
                <div className='statistic-content__attempt-number'>
                  {index + 1}
                </div>

                <div
                  className='statistic-content__attempt-stat'
                  style={{width: `${+item / (maxStatValue / 100)}%`}}
                >
                  {item}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  } else return null

};

export default StatisticContent;
